/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import moment from 'moment';

import { toMonthName, weeklyDescription } from '../../util/lib';

const TransactionStatsListColumn = (timezone) => [
  {
    title: 'Timeline',
    render: (status, record) => {
      const theHour = (record.hour + timezone.offset) % 24;
      return (
        <span>
          {record?.chart === 'hourly'
          && (
          <span>
            {(theHour < 10) ? '0' : ''}
            {theHour}
            h
            {' → '}
            {(theHour < 10 || theHour === 23) ? '0' : ''}
            {(theHour + 1) % 24}
            h
          </span>
)}
          {record?.chart === 'daily'
          && (
          <span>
            {moment().day(record.day).format('ddd')}
            /
            {toMonthName(record.month)}
            /
            {record.year}
          </span>
)}
          {record?.chart === 'weekly'
          && (
          <span>
            {weeklyDescription(record.week, record.month, record.year)}
          </span>
)}
          {record?.chart === 'monthly'
          && <span>{`${record.year}/${toMonthName(record.month)}`}</span>}
          {record?.chart === 'yearly'
          && <span>{`${record.year}`}</span>}
        </span>
      );
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (status) => (
      <span>
        {status}
      </span>
    ),
  },
  {
    title: 'Total txns',
    dataIndex: 'count',
    render: (count) => (
      <span>
        {new Intl.NumberFormat().format(count)}
      </span>
    ),
  },
  {
    title: 'Total value',
    dataIndex: 'value',
    render: (value, record) => (
      <span>
        {new Intl.NumberFormat().format(Number(Math.round(value * 10000) / 10000))}
        {' '}
        {record.currency}
      </span>
    ),
  },
];

export default TransactionStatsListColumn;
